/**
 * Persistence of the Global Project Selector's choice across a browser
 * refresh. A UI preference only: the stored id never grants anything (every
 * query it filters is still authorized by RLS), and the provider re-validates
 * it against the projects the user can actually see before keeping it.
 *
 * The record carries WHO and WHICH COMPANY it was saved for, so a different
 * user -- or the same user in another company -- never inherits it.
 */
const STORAGE_KEY = 'krewup.globalProject';

export interface StoredProjectSelection {
  userId: string;
  companyId: string;
  /** A project id, or 'all'. */
  projectId: string;
}

export function readStoredProjectSelection(): StoredProjectSelection | null {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (parsed && typeof parsed.userId === 'string' && typeof parsed.companyId === 'string' && typeof parsed.projectId === 'string') return parsed;
  } catch {
    // unreadable / blocked storage: behave as if nothing was saved
  }
  return null;
}

export function writeStoredProjectSelection(selection: StoredProjectSelection): void {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(selection));
  } catch {
    // storage unavailable (private mode, quota): the selection just won't survive a refresh
  }
}
